var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFcLegal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 59.6746H38.4546V64.3358H0V59.6746ZM46.2077 35.1818L37.1146 44.2755L39.9731 47.1341L36.6776 50.4297L33.819 47.5711L17.1801 30.9327L14.3214 28.074L17.6171 24.7784L20.4757 27.637L41.9585 6.15426L39.0999 3.29568L42.3954 0L45.2541 2.85869L61.8925 19.4971L64.7511 22.3557L61.4555 25.6512L58.597 22.7931L49.5033 31.8867L80 62.383L76.7044 65.6786L46.2077 35.1818ZM42.9121 31.8862L46.2077 28.5907L55.3013 19.4971L45.2541 9.44982L23.7713 30.9327L33.8185 40.9798L42.9121 31.8862Z",
    fill: "#0088E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFcLegal);
export default __webpack_public_path__ + "static/media/fc-legal.2b49be645d23df90170e6f10c42e2a2f.svg";
export { ForwardRef as ReactComponent };